
































































import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            isConnected: false,
            loading: false,
            toolbar: {
                title: 'Migration',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0,
                        feature: null
                    }
                ],
                right: []
            }
        }
    },
    mounted() {
        //  This setting enables us to prevent users from continuously trying to reconnect their tenant to workspaces, 
        //  workflow will need to be adjusted when we allow multiple workspaces in v2, will need 'disconnect' functionality 
        const v2Setting = this.$store.getters.settingGet('canMigrateToV2')

        if (!v2Setting.data) return
    
        this.isConnected = v2Setting.data.connected

        //  Embed script for calendly
        let embedCalendly = document.createElement('script')
        embedCalendly.setAttribute(
            'src',
            'https://assets.calendly.com/assets/external/widget.js'
        )
        embedCalendly.setAttribute('async', 'async')
        document.head.appendChild(embedCalendly)

        //  Embed calendly css stylesheet
        let calendlyCSS = document.createElement('link')
        calendlyCSS.setAttribute(
            'href',
            'https://assets.calendly.com/assets/external/widget.css'
        )
        calendlyCSS.setAttribute('rel', 'stylesheet')
        document.head.appendChild(calendlyCSS)
    },
    methods: {
        //  This function is the only one with the callback as all we care about is if they're connected or not, doing this allows us to 
        //  disable the connect button only upon successful submission
        popConnectionPrompt(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                icon: 'mdi-connection',
                title: 'Connect With 2.0',
                color: 'primary',
                width: 600,
                component: 'migration-form',
                props: {
                    step: "1"
                },
                closeable: true,
                closeOnSubmit: true, 
                callback: () => {
                    this.isConnected = true
                }
            })
        },
        popMeetingPrompt(): void {
             // @ts-ignore
             Calendly.initPopupWidget({
                url: 'https://calendly.com/d/cqdk-krr-g3n/messagedesk-account-meeting'
            })
        },
        popMigratePrompt(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                icon: 'mdi-folder-move',
                title: 'Begin Data Migraiton',
                color: 'primary',
                width: 600,
                component: 'migration-form',
                props: {
                    step: "2"
                },
                closeable: true
            })
        },
        popPhonePrompt(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                icon: 'mdi-phone',
                title: 'Migrate Phone Number',
                color: 'primary',
                width: 600,
                component: 'migration-form',
                props: {
                    step: "3"
                },
                closeable: true
            })
        }
    }
})
